import type { ColumnDefinition } from '@/common/types/filter';

export const GLOBAL_TABLE_PAGINATION_PER_PAGE = 'global.table.pagination.per-page';
export const FREE_USER_VISIBLE_ROWS = 5;

export const DEFAULT_KEYWORD_IDEAS_COLUMNS_VISIBILITY: Record<string, ColumnDefinition[]> = {
  kt_keyword_ideas: [
    { column: 'search_trend', visible: true },
    { column: 'avg_searches', visible: true },
    { column: 'avg_clicks', visible: true },
    { column: 'ctr', visible: true },
    { column: 'keyword_difficulty', visible: true },
    { column: 'competition', visible: true },
    { column: 'tag_occurrences', visible: true },
    { column: 'character_count', visible: true },
    { column: 'google', visible: true },
  ],
};

export const KEYWORD_MENU_ROUTES = [
  'keyword-research',
  'product-research',
  'product-research-tool',
  'rank-checker',
  'shop-info',
  'tags',
  'traffic-stats-parent',
  'trend-buzz',
  'trending',
  'shop-info',
  'traffic-stats-parent',
  'categories',
  'ai-listing-helper',
  'keyword-lists',
  'listing-audit',
  'bulk-keyword-tool',
  'compare-listings',
];
